import React from "react";

import Table from "../../../components/Table";

export default function AnimaisFiltrados({
  result,
  handleAnimal,
  consulta,
  handleCurrentPage,
  racas,
  sexos,
  categorias,
  variedades,
  totalAnimais
}) {
  return (
    <>
      {result && result.length === 0 && <h3 className="mt-4">Faça a consulta na aba filtro</h3>}

      {result && result.length > 0 && (
        <Table
          initialResult={result}
          handleAnimal={handleAnimal}
          initialConsulta={consulta}
          handleCurrentPage={handleCurrentPage}
          racas={racas}
          sexos={sexos}
          categorias={categorias}
          variedades={variedades}
          totalAnimais={totalAnimais}
        />
      )}
    </>
  );
}
